import { DEFAULT_FG, DEFAULT_BG } from './colors.js';

export class Cell {
  constructor(char, fg = DEFAULT_FG, bg = DEFAULT_BG) {
    this.char = char;
    this.fg = fg;
    this.bg = bg;
  }
}

// Cell helper functions.
export const stringToCells = (text, fg = DEFAULT_FG, bg = DEFAULT_BG) => Array.from(text, ch => new Cell(ch, fg, bg));

export const cellsToString = (cells) => cells.map(cell => cell.char).join("");

const padCells = (cells, width, fgColor = DEFAULT_FG, bgColor = DEFAULT_BG) => {
  let padded = cells.slice();
  while (padded.length < width) {
    padded.push(new Cell(" ", fgColor, bgColor));
  }
  return padded;
};

const centerCells = (cells, width, fgColor = DEFAULT_FG, bgColor = DEFAULT_BG) => {
  const totalSpaces = width - cells.length;
  const leftPaddingCount = Math.floor(totalSpaces / 2);
  const leftPadding = Array.from({ length: leftPaddingCount }, () => new Cell(" ", fgColor, bgColor));
  return leftPadding.concat(cells);
};

export const alignCells = (cells, width, alignment = 'left', fgColor = DEFAULT_FG, bgColor = DEFAULT_BG) => {
  if (alignment === 'center') {
    return centerCells(cells, width, fgColor, bgColor);
  } else if (alignment === 'right') {
    const totalSpaces = width - cells.length;
    const rightPadding = Array.from({ length: totalSpaces }, () => new Cell(" ", fgColor, bgColor));
    return rightPadding.concat(cells);
  } else {
    // Default to left alignment
    return padCells(cells, width, fgColor, bgColor);
  }
}